'use client';

import React, { useState } from 'react';
import { VscMenu } from "react-icons/vsc";
import { IoMdClose } from "react-icons/io";
import { useTranslations } from 'next-intl';
import { useLocale } from 'next-intl';
import { useRouter } from 'next/navigation';
import { GoChevronDown } from "react-icons/go";
import { GoChevronUp } from "react-icons/go";
import Image from 'next/image';
import SocialMedia from './social';
import { FaHome } from "react-icons/fa";
import { Link } from '@/i18n/routing';

// Define the type for a menu item
type MenuItem = {
  title: string;
  handler?: () => void; // Optional handler property
};

// Define the type for dropdown items
type DropdownItem = {
  code: string;
  name: string;
  category: string;
};

const MobileMenu = () => {


  
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const t = useTranslations('Menu');
  const router = useRouter(); // Initialize the router
  const locale = useLocale(); // Get the current locale
  const te = useTranslations('tophero');
  const l = useLocale();
  function images() {
    return l == "ar" ? "/logo-black/شعار-بادليف-أسود.webp" :
      (l == "de" ? "/logo-black/padlev-logo-schwarz.webp" :
        (l == "es" ? "/logo-black/padlev-logo-negro.webp" :
          (l == "fr" ? "/logo-black/padlev-logo-noir.webp" :
            (l == "it" ? "/logo-black/padlev-logo-nero.webp" :
              (l == "nl" ? "/logo-black/padlev-logo-zwart.webp" :
                (l == "pt" ? "/logo-black/padlev-logo-preto.webp" :
                  (l == "ru" ? "/logo-black/padlev-logo-chernyy.webp" :
                    (l == "sv" ? "/logo-black/padlev-logo-svart.webp" :
                      "/logo-black/padlev-logo-black.webp"
                    )
                  )
                )
              )
            )
          )
        )
      );
  }

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleDropdown = (dropdownName: string) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  const handleNavigateWithQuery = (query: string) => {
    // Include the locale and query parameters in the URL
    router.push(`/${locale}/p?q=${encodeURIComponent(query)}`);
    toggleSidebar(); // Close the sidebar after navigation
  };

  const handle = (query: string) => {
    // Include the locale and query parameters in the URL
    router.push(`/${locale}/${encodeURIComponent(query)}`);
    toggleSidebar(); // Close the sidebar after navigation
  };

  const menuItems: Record<string, MenuItem> = {
    blog: { title: t('blog'), handler: () => handle('blog') },
    junior: { title: t('Junior'), handler: () => handleNavigateWithQuery('jn') },
    man: { title: t('man'), handler: () => handle('#') },
    woman: { title: t('woman'), handler: () => handle('#') },
    rackets: { title: t('rackets'), handler: () => handle('#') },
    accessories: { title: t('accessories'), handler: () => handle('#') },
    bags: { title: t('bags'), handler: () => handleNavigateWithQuery('bgs') }, // Add handler for bags
    random: { title: t('random'), handler: () => handle('product') },
  };

  const dropdownItems: Record<string, DropdownItem[]> = {
    man: [
      { code: '1', name: t('padel shoes') , category:'sm'},
      { code: '2', name: t('T-shirt')  , category:'tsm'},
      { code: '3', name: t('sweatshirt') , category:'swsm'},
      { code: '4', name: t('sock') , category:'sockm'},
      { code: '5', name: t('short') , category:'srtm'},
      { code: '6', name: t('polo shirt') , category:'psm'},
      { code: '7', name: t('long pants') , category:'lptsm'},
      { code: '8', name: t('legging') , category:'legm'},
      { code: '9', name: t('jacket') , category:'jcktm'},
      { code: '10', name: t('cap') , category:'capm'},
    ],
    woman: [
      { code: '1', name: t('dress') , category:'drs'},
      { code: '2', name: t('visor') , category:'vsr'},
      { code: '3', name: t('top') , category:'top'},
      { code: '4', name: t('padel shoes') , category:'sm'},
      { code: '5', name: t('T-shirt') , category:'tswm'},
      { code: '6', name: t('sweatshirt'), category:'swsw'},
      { code: '7', name: t('sock') , category:'sockm'},
      { code: '8', name: t('short') , category:'srtw'},
      { code: '9', name: t('long pants'), category:'lptsw'},
      { code: '10', name: t('legging')  , category:'legw'},
      { code: '11', name: t('jacket') , category:'jcktw'},
      { code: '12', name: t('cap') , category:'capm'},
    ],
    rackets: [
      { code: '1', name: t('beginner') , category:'rkb'},
      { code: '2', name: t('intermediate') , category:'rki'},
      { code: '3', name: t('professional') , category:'rkp'},
    ],
    accessories: [
    { code: '1', name: t('balls') , category:'bl'},
    { code: '2', name: t('overgrip') , category:'ogri'},
    { code: '3', name: t('racket protector') , category:'rkpt'},
    { code: '4', name: t('protective gear'), category:'ptg'},
    { code: '5', name: t('sunglasses') , category:'sung'},
    { code: '6', name: t('towel') , category:'twl'},
    { code: '7', name: t('resistance bands') , category:'rb'},
    { code: '8', name: t('water bottle') , category:'wb'},
    { code: '9', name: t('sweatbands'), category:'swb'},
    ],
  };

  return (
    <div className="flex custom:hidden overflow-y-auto">
      {/* Sidebar Toggle Button */}
      <div className='flex gap-4'>
      <Link href="/" rel="preload" aria-label={t('home')}>
      <FaHome className="size-6" />
      </Link>
            <button onClick={toggleSidebar} aria-label={t('menu')}>
        <VscMenu className="size-6" />
      </button>

      </div>
  
      {/* Sidebar */}
      {locale === "ar" ? (
        <div
          className={`fixed inset-y-0 overflow-y-auto right-0 w-64 bg-yel shadow-lg transform transition-transform duration-300 ease-in-out z-40 ${
            isSidebarOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
          dir="rtl" // Set RTL direction for Arabic
        >
          <div className="p-4">
            <div className="flex justify-between items-center cursor-pointer mb-6">
              <div className="relative h-5 w-32">
                <Image
                    src={images() || "/logo.png"} // or "/logo.svg" if using an SVG
                    alt={te('logo-padlev')}
                    fill
                    sizes='100%'
                    style={{ objectFit: 'contain' }} // Maintain aspect ratio
                    priority // Ensures it loads faster
                />
              </div>
              <button onClick={toggleSidebar}>
                <IoMdClose className="size-6 hover:text-bl" />
              </button>
            </div>

            <div>
              {Object.entries(menuItems).map(([key, value]) => (
                <div key={key} className="mb-5 uppercase">
                  {dropdownItems[key as keyof typeof dropdownItems] ? (
                    <div>
                      <button
                      aria-label={t('menu')}
                        onClick={() => toggleDropdown(key)}
                        className="flex justify-between items-center w-full text-right" // Align text to the right for RTL
                      >
                        <span>{value.title}</span>
                        <span>
                          {openDropdown === key ? <GoChevronUp className="size-6" /> : <GoChevronDown className="size-6" />}
                        </span>
                      </button>
                      {openDropdown === key && (
                        <div className="pr-4 mt-4 text-sm text-gray-600"> {/* Use `pr-4` for RTL padding */}
                          {dropdownItems[key as keyof typeof dropdownItems].map((item) => (
                            <p
                              key={item.code}
                              className="mb-4 cursor-pointer capitalize"
                              onClick={() => handleNavigateWithQuery(item.category)}
                            >
                              {item.name}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    // Check if the item has a handler
                    value.handler ? (
                      <button
                      aria-label={t('menu')}
                        onClick={value.handler}
                        className="text-gray-700 hover:text-gray-900 w-full text-right" // Align text to the right for RTL
                      >
                        {value.title}
                      </button>
                    ) : null
                  )}
                  <hr className="flex-grow border-t border-gray-300 mt-2" />
                </div>
              ))}
            </div>

            <div className="flex flex-col gap-3">
              <p className="font-semibold uppercase">{t('follow us')}</p>
              <SocialMedia/>
            </div>
          </div>
        </div>
      ) : (
        <div
          className={`fixed inset-y-0 left-0 overflow-y-auto w-64 bg-yel shadow-lg transform transition-transform duration-300 ease-in-out z-40 ${
            isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
          }`}
          dir="ltr" // Set LTR direction for non-Arabic
        >
          <div className="p-4">
            <div className="flex justify-between items-center cursor-pointer mb-6">
              <div className="relative h-5 w-32">
                <Image
                     src={images()} // or "/logo.svg" if using an SVG
                     alt={te('logo-padlev')}
                  fill
                  style={{ objectFit: 'contain' }} // Maintain aspect ratio
                  priority // Ensures it loads faster
                />
              </div>
              <button onClick={toggleSidebar} aria-label={t('menu')}>
                <IoMdClose className="size-6 hover:text-bl" />
              </button>
            </div>

            <div>
              {Object.entries(menuItems).map(([key, value]) => (
                <div key={key} className="mb-5 uppercase">
                  {dropdownItems[key as keyof typeof dropdownItems] ? (
                    <div>
                      <button
                      aria-label={t('menu')}
                        onClick={() => toggleDropdown(key)}
                        className="flex justify-between items-center w-full text-left" // Align text to the left for LTR
                      >
                        <span>{value.title}</span>
                        <span>
                          {openDropdown === key ? <GoChevronUp className="size-6" /> : <GoChevronDown className="size-6" />}
                        </span>
                      </button>
                      {openDropdown === key && (
                        <div className="pl-4 mt-4 text-sm text-gray-600"> {/* Use `pl-4` for LTR padding */}
                          {dropdownItems[key as keyof typeof dropdownItems].map((item) => (
                            <li
                              key={item.code}
                              className="mb-4 cursor-pointer capitalize"
                              onClick={() => handleNavigateWithQuery(item.category)}
                            >
                              {item.name}
                            </li>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    // Check if the item has a handler
                    value.handler ? (
                      <button
                      aria-label={t('menu')}
                        onClick={value.handler}
                        className="text-gray-700 hover:text-gray-900 w-full text-left" // Align text to the left for LTR
                      >
                        {value.title}
                      </button>
                    ) : null
                  )} 
                  <hr className="flex-grow border-t border-gray-300 mt-2" />
                </div> 
              ))}
            </div>

            <div className="flex flex-col gap-3">
              <p className="font-semibold uppercase">{t('follow us')}</p>
            <SocialMedia/>
            </div>
          </div>
        </div>
      )}

      {/* Overlay to close sidebar when clicking outside */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30"
          onClick={toggleSidebar}
        ></div>
      )}
    </div>
  );
};

export default MobileMenu;